import { useEffect } from 'react'
import useRefreshToken from './useRefreshToken'
import useAuthExtranet from './useAuthExtranet'
import { middleofficeRequest } from '../axios'

const useAxiosPrivate = () => {
  const refresh = useRefreshToken()
  const { auth } = useAuthExtranet()

  useEffect(() => {
    const requestIntercept = middleofficeRequest.interceptors.request.use(
      (config) => {
        if (!config.headers['Authorization']) {
          config.headers['Authorization'] = `Bearer ${auth?.accessToken}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    let isInterceptingError = false

    const responseIntercept = middleofficeRequest.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (isInterceptingError) {
          return Promise.reject(error)
        }
        isInterceptingError = true
        const prevRequest = error?.config
        if (
          error?.response?.status === 403 ||
          (error?.response?.status === 401 && !prevRequest?.sent)
        ) {
          prevRequest.sent = true
          const newAccessToken = await refresh()
          prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`
          return middleofficeRequest(prevRequest)
        }
        isInterceptingError = false
        return Promise.reject(error)
      }
    )

    return () => {
      middleofficeRequest.interceptors.request.eject(requestIntercept)
      middleofficeRequest.interceptors.response.eject(responseIntercept)
    }
  }, [])

  return middleofficeRequest
}

export default useAxiosPrivate
